import type { ExportItem, FetchFn } from './types';

async function headSize(url: string, fetchFn: FetchFn, signal?: AbortSignal): Promise<number | null> {
  try {
    const res = await fetchFn(url, { method: 'HEAD', signal });
    if (!res.ok) return null;
    const length = Number(res.headers.get('content-length'));
    return Number.isFinite(length) && length > 0 ? length : null;
  } catch {
    return null;
  }
}

/** Returns a copy of the items with `size` filled in. Never throws; unknown sizes stay null. */
export async function measureItems(
  items: ExportItem[],
  fetchFn: FetchFn = fetch,
  signal?: AbortSignal,
  concurrency = 8,
): Promise<ExportItem[]> {
  const measured = items.slice();
  let next = 0;
  const worker = async () => {
    while (next < measured.length) {
      const index = next;
      next += 1;
      measured[index] = { ...measured[index], size: await headSize(measured[index].url, fetchFn, signal) };
    }
  };
  await Promise.all(Array.from({ length: Math.min(concurrency, measured.length) }, worker));
  return measured;
}
